import React from 'react';
import { formatTime } from '../utils/formatTime';

interface TimerDisplayProps {
  label: string;
  timeRemaining: number;
  isActive: boolean;
  compact?: boolean;
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({
  label,
  timeRemaining,
  isActive,
  compact = false
}) => {
  return (
    <div className={`${compact ? 'flex flex-col items-center' : 'w-full'}`}>
      <div className={`text-terminal-green ${compact ? 'text-center text-sm mb-1' : ''}`}>
        {label}
      </div>
      <div
        className={`font-vt323 text-terminal-green ${
          isActive ? 'animate-pulse' : ''
        } ${compact ? 'text-center text-lg' : 'text-4xl'}`}
      >
        {formatTime(timeRemaining)}
      </div>
    </div>
  );
};

export default TimerDisplay;